
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStackedOpen as ObiTwowayStackedOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-open.js';
 
 
 

 
 export const ObiTwowayStackedOpen = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-open',
   elementClass: ObiTwowayStackedOpenElement,
   events: {
     
   }
  });
 
 